import { observer } from 'mobx-react-lite';
import { useComputed } from 'owa-react-hooks/lib/useComputed';
import { logUsage } from 'owa-analytics';
import * as React from 'react';
import {
    CategoryColorValue,
    getCategoryColorsForCategory,
    getMasterCategoryList,
} from 'owa-categories';
import CategoryType from 'owa-service/lib/contract/CategoryType';

const styles = require('./Category.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CategoryProps {
    category: string;
    categoryList?: CategoryType[];
    actionSource: string;
    isLastInWell: boolean;
    containerClassName?: string;
    onCategoryClicked?: (
        ev: React.MouseEvent<unknown>,
        category: string,
        actionSource: string
    ) => void;
}

export default observer(function Category(props: CategoryProps) {
    const categoryContainerElement = React.useRef<HTMLElement>();
    const categoryColor = useComputed(
        (): CategoryColorValue => {
            return getCategoryColorsForCategory(
                props.category,
                props.categoryList ? props.categoryList : getMasterCategoryList()
            );
        }
    );
    const onCategoryClicked = (ev: React.MouseEvent<unknown>) => {
        if (props.onCategoryClicked) {
            logUsage('Category_Well_Click', [props.actionSource]);
            props.onCategoryClicked(ev, props.category, props.actionSource);
        }
    };
    const onMouseEnterCategory = () => {
        if (props.onCategoryClicked) {
            categoryContainerElement.current.style.borderColor = categoryColor.get().textColor;
        }
    };
    const onMouseLeaveCategory = () => {
        if (props.onCategoryClicked) {
            categoryContainerElement.current.style.borderColor = categoryColor.get().secondaryColor;
        }
    };
    const cStyle = {
        backgroundColor: categoryColor.get().primaryColor,
        borderColor: categoryColor.get().secondaryColor,
        color: categoryColor.get().textColor,
        cursor: props.onCategoryClicked ? 'pointer' : 'initial',
    };
    const categoryName = props.category;
    const containerClassnames = classNames(
        props.containerClassName,
        props.isLastInWell ? styles.lastCategoryContainer : styles.categoryContainer
    );
    const categoryLabel = <span className={styles.categoryName}>{categoryName}</span>;
    return (
        <div
            ref={r => (categoryContainerElement.current = r)}
            key={categoryName}
            className={containerClassnames}
            style={cStyle}
            title={categoryName}
            onMouseEnter={onMouseEnterCategory}
            onMouseLeave={onMouseLeaveCategory}
            onClick={onCategoryClicked}>
            {categoryLabel}
        </div>
    );
});
